






































































































































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from './Base';

Vue.config.ignoredElements = ['star'];

interface TrustPilotStarsInterface {
    id: string;
    country: string;
    displayName: string;
    name: {
        referring: string[];
        identifying: string;
    };
    score: {
        stars: number;
        trustScore: number
    };
    status: string;
    websiteUrl: string;
    numberOfReviews: {
        total: number,
        usedForTrustScoreCalculation: number,
        oneStar: number,
        twoStars: number,
        threeStars: number,
        fourStars: number,
    };
    links: [
        {
            href: string,
            rel: string,
            method: string,
        }
    ];
    badFit: any;
}

@Component
export default class TrustPilotStars extends BaseComponent implements TrustPilotStarsInterface {
    public links: [
        {
            href: string;
            rel: string;
            method: string;
        }
    ];
    public badFit: any;
    public id: string;
    public country: string;
    public displayName: string;
    public name;
    public score: {
        stars: number; trustScore: number;
    };
    public status: string;
    public websiteUrl: string;
    public numberOfReviews: {
        total: number;
        usedForTrustScoreCalculation: number;
        oneStar: number;
        twoStars: number; threeStars: number;
        fourStars: number;
    };

    protected starsArray: number[] = [];
    protected trustPilotStars = window.trustPilotStars || null;

    protected mounted(): void {
        if (this.trustPilotStars && !this.trustPilotStars.errorCode) {
            const starsScore = this.trustPilotStars.score.stars;

            for (let i = 1; i <= 5; i++) {
                if (starsScore < i) {
                    this.starsArray.push(0);
                } else {
                    this.starsArray.push(1);
                }
            }

            if (!Number.isInteger(starsScore)) {
                this.starsArray[~~starsScore] = 2;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TrustPilotStars.vue